// extracted by mini-css-extract-plugin
export var wrapper = "skill-module--wrapper--3w4yG";
export var image = "skill-module--image--34P1I";